import MailSource from "@/domain/enums/MailSource";
import SmartLabel from "@/domain/enums/SmartLabel";
import EmailAIDetails from "./EmailAIDetails";
import EmailAttachment from "./EmailAttachement";
import EmailUser from "./EmailUser";
import EventDetail from "./EventDetail";
import LinkObject from "./LinkObject";

export type MailsListId = MailSource | SmartLabel | string;

export enum MailStatus {
    READ = "read",
    UNREAD = "unread",
    SPAM = "spam",
    TRASH = "trash",
}

export enum MailComponentSize {
    SMALL = "1x1",
    NARROW = "1x2",
    WIDE = "2x1",
    LARGE = "2x2",
}

export enum MailStatusVariant {
    READ = "read",
    UNREAD = "unread",
    FOCUS_UNREAD = "focusUnread",
    FOCUS_READ = "focusRead",
}

export enum BodyContentType {
    TEXT = "text",
    HTML = "html",
}

type EmailProps = {
    id: string;
    internetMessageId: string;
    uniqueMailvistaId: string;
    parentFolderId: string;
    subject: string;
    message: string;
    messagePreview: string;
    isRead: boolean;
    from: EmailUser;
    to: EmailUser[];
    /** Absent tant que l'analyse n'a pas eu lieu (le SDK le declare optionnel). */
    smartLabel?: SmartLabel;
    isFocus: boolean;
    isStarred: boolean;
    isImportant: boolean;
    sentDateTime: Date;
    attachments: EmailAttachment[];
    isUserProcessed: boolean;
    aiDetails?: EmailAIDetails;
    componentSize: MailComponentSize;
    linkedEventDetails?: EventDetail;
    cc: EmailUser[];
    bcc: EmailUser[];
    uniqueBody: string;
    conversationId: string;
    links?: LinkObject[];
    hasAttachment: boolean;
    bodyContentType: BodyContentType;
    uniqueBodyContentType: BodyContentType;
};

export default class Email {
    id: string;

    internetMessageId: string;

    uniqueMailvistaId: string;

    parentFolderId: string;

    subject: string;

    message: string;

    messagePreview: string;

    isRead: boolean;

    from: EmailUser;

    to: EmailUser[];

    cc: EmailUser[];

    bcc: EmailUser[];

    smartLabel?: SmartLabel;

    isFocus: boolean;

    isStarred: boolean;

    isImportant: boolean;

    sentDateTime: Date;

    attachments: EmailAttachment[];

    isUserProcessed: boolean;

    aiDetails?: EmailAIDetails;

    linkedEventDetails?: EventDetail;

    componentSize: MailComponentSize;

    uniqueBody: string;

    conversationId: string;

    links?: LinkObject[];

    hasAttachment: boolean;

    bodyContentType: BodyContentType;

    uniqueBodyContentType: BodyContentType;

    constructor({
        id,
        internetMessageId,
        uniqueMailvistaId,
        parentFolderId,
        subject,
        message,
        messagePreview,
        isRead,
        isStarred,
        isImportant,
        from,
        to,
        sentDateTime,
        smartLabel,
        isFocus,
        attachments,
        isUserProcessed,
        aiDetails,
        componentSize,
        linkedEventDetails,
        cc,
        bcc,
        uniqueBody,
        conversationId,
        links,
        hasAttachment,
        bodyContentType,
        uniqueBodyContentType,
    }: EmailProps) {
        this.id = id;
        this.internetMessageId = internetMessageId;
        this.uniqueMailvistaId = uniqueMailvistaId;
        this.parentFolderId = parentFolderId;
        this.subject = subject;
        this.message = message;
        this.messagePreview = messagePreview;
        this.isRead = isRead;
        this.isStarred = isStarred;
        this.isImportant = isImportant;
        this.from = from;
        this.to = to;
        this.sentDateTime = sentDateTime;
        this.smartLabel = smartLabel;
        this.isFocus = isFocus;
        this.attachments = attachments;
        this.isUserProcessed = isUserProcessed;
        this.aiDetails = aiDetails;
        this.componentSize = componentSize;
        this.linkedEventDetails = linkedEventDetails;
        this.cc = cc;
        this.bcc = bcc;
        this.uniqueBody = uniqueBody;
        this.conversationId = conversationId;
        this.links = links;
        this.hasAttachment = hasAttachment;
        this.bodyContentType = bodyContentType;
        this.uniqueBodyContentType = uniqueBodyContentType;
    }

    getMailStatus(): MailStatusVariant {
        switch (true) {
            case this.isFocus && !this.isRead:
                return MailStatusVariant.FOCUS_UNREAD;
            case this.isFocus:
                return MailStatusVariant.FOCUS_READ;
            case !this.isRead:
                return MailStatusVariant.UNREAD;
            default:
                return MailStatusVariant.READ;
        }
    }
}
